import http from './http';

export default {
  // 发送邮箱验证码
  send(data) {
    return http.post('/Ems/send', data);
  },
  
  // 验证邮箱验证码
  verify(data) {
    return http.post('/Ems/check', data);
  },
  
  // 检查邮箱是否可以注册/使用
  checkEmail(data) {
    return http.post('/Ems/checkEmail', data);
  }
};
